<template>
  <PageWrapper :handleBack="goToDashboard">
    <FormWrapper
      wrapperClass="margin-top-16"
      bodyClass="padding-x-16 padding-top-16 min-height-300"
      :handleSubmit="handleSubmit"
      :loading="loading"
      :submitButtonText="$lang.download"
    >
      <Dropdown
        :title="$lang.selectCenterExecute"
        :label="$lang.centerExecute"
        :placeholder="$lang.centerExecute"
        :value="form.centerExecute"
        name="centerExecute"
        id="centerExecute"
        :vuelidateObj="$v.form.centerExecute"
        :asyncSearch="getCenterExecuteOptions"
        :insideFeature="true"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </FormWrapper>
  </PageWrapper>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { PageWrapper } from "@/components/re-design";
import { FormWrapper, Dropdown } from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { checkPermission, generateError, goToRoute } from "@/shared/utils";
import { exportCenterExecuteMeetingBoard } from "@/modules/kanoon/services";
import { getCenterExecuteCombo } from "@/services";

export default {
  mixins: [inputMixin],
  components: { PageWrapper, FormWrapper, Dropdown },
  validations() {
    return {
      form: {
        centerExecute: { required },
      },
    };
  },
  data() {
    return {
      form: {
        centerExecute: null,
      },
      loading: false,
    };
  },
  methods: {
    checkPermission,
    getCenterExecuteCombo,
    goToDashboard() {
      goToRoute("dashboard", {}, {}, false);
    },
    async getCenterExecuteOptions(text = null) {
      try {
        const CENTER_EXECUTE_STATUS = 3;
        const options = await getCenterExecuteCombo(
          text,
          CENTER_EXECUTE_STATUS
        );
        return options;
      } catch (error) {
        generateError(error);
      }
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loading = true;
        const centerExecuteCode = pathOr(
          null,
          ["centerExecute", "id"],
          this.form
        );
        const response = await exportCenterExecuteMeetingBoard(
          centerExecuteCode
        );
        const { link } = response;
        window.open(link, "_blank");
        this.resetForm();
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
